import React from "react";
import * as PR from "../prime-react/index";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { anomaliesScreenEnabled } from "../utils/reuse";

const BettingMenuBar = () => {
    const navigate = useNavigate();
    const pathname = window.location.pathname;
    const navigatePath = (selectedPath) => {
        pathname !== selectedPath && navigate(selectedPath)
    }
    const role = useSelector(state => state.auth.role);
    

    const allItems = [
        {
            id: 'insights',
            label: 'Insights',
            className: (pathname === '/betting-data') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/betting-data'),
            isVisible: true
        },
        {
            id: 'players',
            label: 'Players',
            className: (pathname.includes('/player-analytics')) ? 'p-menuitem-active' : '',
            command: () => navigatePath('/player-analytics'),
            isVisible: true
        },
        {
            id: 'Anomalies',
            label: 'Anomalies',
            className: (pathname === '/anomalies') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/anomalies'),
            isVisible: anomaliesScreenEnabled
        },
        {
            id: 'Baseline Configuration',
            label: 'Baseline Configuration',
            className: (pathname === '/baseline-configuration') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/baseline-configuration'),
            isVisible: anomaliesScreenEnabled
        }
    ];

    const items = allItems.filter(item => item.isVisible);

    return (
        <>
            {role === 'analyst' && <div className={`menu-section ${role === 'regulator'
                    ? 'regulator-menu'
                    : role === 'member'
                        ? 'member-menu'
                        : role === 'analyst'
                            ? 'analyst-menu'
                            : role === 'managedmember'
                                ? 'member-menu'
                                : role === 'governingbody'
                                    ? 'regulator-menu'
                                    : ''
                }`}>
                <PR.Menubar model={items} />
            </div>
            }
        </>
    );
};

export default BettingMenuBar;